import useThirdPartyScriptEndpoints from '@/composables/api/useThirdPartyScriptEndpoints';

const { sendNsureDeviceId } = useThirdPartyScriptEndpoints();

window.nSureAsyncInit = (deviceId) => {
  window.nSureSDK.init(import.meta.env.VITE_NSURE_APP_ID);
  // Send it to the SPA-BE
  sendNsureDeviceId({ deviceId });
};
